import { IntegrationConfirmationDialogContent } from '@modules/integrationsV2/components/IntegrationConfirmationDialogContent';
import { PRIVATE_DISCORD_CONNECTION_HELP_CENTER_DOC } from '@modules/integrationsV2/constants';
import { OpenInNewRounded } from '@mui/icons-material';
import { Box, Link, Stack, Typography } from '@mui/material';

interface DiscordPrivateChannelConfigConfirmationModalProps {
  onConfirm: () => void;
  channelName: string;
}

export const DiscordPrivateChannelConfigConfirmationModal = ({
  onConfirm,
  channelName,
}: DiscordPrivateChannelConfigConfirmationModalProps) => {
  return (
    <IntegrationConfirmationDialogContent
      title="Hold up! Have you configured Discord correctly?"
      content={
        <Stack spacing={2}>
          <Typography variant="body2">
            Is "
            <Box component="span" fontWeight="bold">
              {channelName}
            </Box>
            " a private channel? Enterpret can only send reports to private
            channels if the following are done:
          </Typography>
          <Box
            component="ul"
            sx={{
              pl: 2,
            }}
          >
            <Typography variant="body2" component="li">
              '
              <Box component="span" fontWeight="bold">
                Enterpret
              </Box>
              ' is added to '
              <Box component="span" fontWeight="bold">
                Roles
              </Box>
              ' of the private channel
            </Typography>
            <Typography variant="body2" component="li">
              '
              <Box component="span" fontWeight="bold">
                Enterpret Bot
              </Box>
              ' is added to '{' '}
              <Box component="span" fontWeight="bold">
                Members
              </Box>
              ' of the private channel
            </Typography>
          </Box>
          <Stack
            component={Link}
            direction="row"
            alignItems="center"
            spacing={0.5}
            href={PRIVATE_DISCORD_CONNECTION_HELP_CENTER_DOC}
            target="_blank"
            underline="hover"
            variant="body2"
          >
            <Box>See how to add</Box>
            <OpenInNewRounded
              sx={{
                fontSize: '1rem',
              }}
              color="inherit"
            />
          </Stack>
        </Stack>
      }
      onConfirm={onConfirm}
    />
  );
};
